const config = {
    notice: {
        messageDuration: 2000 // 消息提示持续时间（可选）默认为：2000毫秒
    }
}

export default config